var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',[_vm._v(_vm._s(this.$props.success ? 'Well done' : ("Bad luck the answer was " + _vm.answer)))]),_c('v-btn',{attrs:{"icon":""},on:{"click":_vm.refresh}},[_c('v-icon',[_vm._v("mdi-reload")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }